const componentMap = document.querySelector('[data-zoq-component-map]');
if (componentMap) {
  const components = JSON.parse(componentMap.textContent);
  const pending = new Set();
  let scheduled = false;
  const scan = () => {
    scheduled = false;
    for (const [selector, url] of Object.entries(components)) {
      if (pending.has(selector) || !document.querySelector(selector)) continue;
      pending.add(selector);
      import(url).catch(() => pending.delete(selector));
    }
  };
  const observer = new MutationObserver((records) => {
    if (scheduled || !records.some((record) => record.addedNodes.length)) return;
    scheduled = true;
    queueMicrotask(scan);
  });
  const connect = () => {
    scan();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };
  window.addEventListener('pagehide', () => observer.disconnect());
  window.addEventListener('pageshow', connect);
  connect();
}
